import React from "react";
import { connect } from "react-redux";
import { Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import {
  ActionsRow,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import * as configurationActions from "../../../actions/configurationActions";
import { DetailValue } from "@mc/mc-legacy";
import "./FlowConfigurationsList.scss";
import FlowConfigurationForm from "../../forms/FlowConfigurationForm";
import * as appUtils from "../../../utils/appUtils";
import {cleanSigners, cleanSteps} from "../../../utils/appUtils";

class FlowConfigurationsList extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props, force = false) => {
    props.dispatch(configurationActions.fetchFlowConfigurationsIfNeeded(force));
  };

  handleEditConfig = (item) => {
    const { dispatch } = this.props;
    const { steps, ...other } = item;

    dispatch(
      modal.ModalActions.show(
        FlowConfigurationForm,
        {
          onSubmit: (data) => {
              const { steps, ...other } = data;
              const dataFinal = {
                  ...other,
                  steps: cleanSteps(steps),
              };
              return QSignAdminApi.updateFlowConfiguration(dataFinal.id, dataFinal);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(configurationActions.fetchFlowConfigurationsIfNeeded(true));
          },
          initialValues: {
            ...other,
            steps: steps.length === 0 ? [{approvers: [{pracovnikId: null}]}] : steps,
          },
        },
        "Úprava konfigurace",
        {}
      )
    );
  };
  handleDeleteConfig = (item) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení smazání",
        "Opravdu chcete smazat konfiguraci " + item.name + "?",
        () =>
          QSignAdminApi.deleteFlowConfiguration(item.id).then(() => {
            dispatch(configurationActions.fetchFlowConfigurationsIfNeeded(true));
          }),
        null,
        "Potvrdit"
      )
    );
  };
  renderItem = (item, key) => {
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item)}>
            <Row>
              <Col>
                  <h2>{item.name} ({item.code})</h2>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };
  renderActions = (item) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v" className="item-actions-icon" />}>
          <DropdownItem key="1" onClick={() => this.handleEditConfig(item)}>
            Upravit
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleDeleteConfig(item)}>
            Smazat
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { flowConfigurationList } = this.props;

    if (!flowConfigurationList) {
      return <Loader />;
    }
    return (
      <InfiniteScroll className="config-list" bordered>
        {flowConfigurationList.isFetching && <HorizontalLoader key={'loader'} hover />}
        {flowConfigurationList.rows.map((item, key) => {
          return this.renderItem(item, key);
        })}
      </InfiniteScroll>
    );
  }
}

function mapStateToProps(state) {
  return {
    flowConfigurationList: utils.storeFromArea(state, configurationActions.FLOW_CONFIGURATION_LIST),
  };
}

export default connect(mapStateToProps)(FlowConfigurationsList);
